module.exports = __webpack_public_path__ + "img/wechat_black.23853f0b.png";